import { useCallback, useEffect, useState } from 'react'
import { ApiError, get } from './api'

export interface FetchState<T> {
  data: T | null
  error: ApiError | null
  loading: boolean
  reload: () => void
}

/** Charge `path` (null = ne rien charger) et le recharge quand il change. */
export function useFetch<T>(path: string | null): FetchState<T> {
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<ApiError | null>(null)
  const [loading, setLoading] = useState(path !== null)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (path === null) return
    let alive = true
    setLoading(true)
    setError(null)
    get<T>(path)
      .then((d) => alive && setData(d))
      .catch(
        (e: unknown) => alive && setError(e instanceof ApiError ? e : new ApiError(0, String(e))),
      )
      .finally(() => alive && setLoading(false))
    return () => {
      alive = false
    }
  }, [path, tick])

  const reload = useCallback(() => setTick((t) => t + 1), [])
  return { data, error, loading, reload }
}
